// This file is auto-generated by scripts/generate-custom-pages-registry.ts
// Do not edit manually - changes will be overwritten

import type { ComponentType } from 'react'

import { type PageComponentProps } from '@typings/components/page'

import customPageExample from '@custom/pages/custom-page-example/page'
import homepage from '@custom/pages/homepage/page'
import plans from '@custom/pages/plans/page'
import superhumanGoIntro from '@custom/pages/superhuman-go-intro/page'

export type CustomPageComponent = ComponentType<PageComponentProps>

export interface CustomPageRegistry {
  [slug: string]: CustomPageComponent
}

// Registry mapping slugs to their custom components (static imports for SSR compatibility)
export const customPageRegistry: CustomPageRegistry = {
  '/custom-page-example': customPageExample,
  '/': homepage,
  '/plans': plans,
  '/superhuman-go-intro': superhumanGoIntro,
}

// Available custom page slugs
export const customPageSlugs = Object.keys(customPageRegistry)
